var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { requestRefundDataProps } from '../../const/analytics';
import StepButton from '../step-button';
var RequestRefundButton = function (_a) {
    var onClickHandler = _a.onClickHandler;
    var t = useTranslation().t;
    return (_jsx(StepButton, __assign({ onClick: onClickHandler }, requestRefundDataProps, { textContent: t('button.requestRefundCheck'), primary: true })));
};
export default RequestRefundButton;
